export enum SortDirectionEnum {
  Up = 'up',
  Down = 'down',
}
